import { useTheme } from '@chakra-ui/react';
import { PieChart, Pie, ResponsiveContainer, Cell, Tooltip } from 'recharts';
import styled from 'styled-components';

interface DonutChartProps {
  percentage: number;
}

const CustomTooltipContainer = styled.div`
  width: 180px;
  background-color: #fff;
  box-shadow: 0 1px 4px 1px rgba(0, 0, 0, 0.15);
  border: 0.5px solid rgba(0, 0, 0, 0.1);
  padding: 8px;
  border-radius: 5px;
  font-family: 'Inter';
  font-size: '10px';
`;
const ColorDot = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 6px;
  background-color: ${({ color }) => color};
`;
const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
`;
const CustomTooltipLabel = styled.p<{ fontSize?: string; color?: string }>`
  font-size: ${({ fontSize }) => fontSize || '10px'};
  font-weight: 700;
  color: ${({ color }) => color || '#777'};
`;

export const DonutChart = ({ percentage }: DonutChartProps) => {
  const { colors } = useTheme();
  const total = percentage < 100 ? 100 : percentage;
  const valueToShow = percentage || 0;
  const remainingValue = total - valueToShow;

  const data = [
    { name: 'Success Rate', value: valueToShow, color: colors.primary },
    { name: 'Failure Rate', value: remainingValue, color: colors.primary2Bg },
  ];

  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      return (
        <CustomTooltipContainer>
          {payload?.map((item: any) => {
            const formattedValue = !isNaN(item?.value)
              ? Number(item?.value)?.toFixed(2)
              : '0.00';

            return (
              <LabelWrapper key={item?.name}>
                <ColorDot color={item?.payload?.color} />
                <CustomTooltipLabel
                  color={colors.text.secondary}
                  fontSize="12px"
                >{`${item?.name} : ${formattedValue}%`}</CustomTooltipLabel>
              </LabelWrapper>
            );
          })}
        </CustomTooltipContainer>
      );
    }
    return null;
  };

  return (
    <ResponsiveContainer width="100%" height="100%">
      <PieChart>
        <text
          x="50%"
          y="50%"
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize={16}
        >
          {valueToShow}%
        </text>
        <Pie
          data={data}
          dataKey="value"
          cx="50%"
          cy="50%"
          innerRadius={35}
          outerRadius={50}
          style={{ outline: 'none' }}
          fill="#8884d8"
        >
          {data.map((entry, index) => (
            <Cell key={index} fill={entry.color} />
          ))}
        </Pie>
        <Tooltip
          cursor={{ fill: 'transparent' }}
          content={<CustomTooltip />}
          wrapperStyle={{ outline: 'none' }}
        />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default DonutChart;
